import React, { useEffect, useState } from "react";
import "./Header.scss";
import logo from "../../../img/TopRingLogo.png";

// если появится логотип, раскомментируй и подставь путь
// import logo from "../../assets/logo.png";

export default function Header() {
  const [open, setOpen] = useState(false);

  // фикс: блокируем прокрутку фона, когда открыт мобильный бургер
  useEffect(() => {
    if (open) document.body.classList.add("noscroll");
    else document.body.classList.remove("noscroll");
    return () => document.body.classList.remove("noscroll");
  }, [open]);

  const closeMenu = () => setOpen(false);

  // якоря ведут на главную (/#id), календарь — отдельная страница
  const links = [
    { href: "/#about", label: "Par mums" },
    { href: "/#programs", label: "Programmas" },
    { href: "/#coaches", label: "Treneri" },
    { href: "/#schedule", label: "Grafiks" },
    { href: "/#pricing", label: "Cenas" },
    { href: "/#gallery", label: "Galerija" },
    { href: "/#contact", label: "Kontakti" },
  ];

  return (
    <header className="site-header" role="banner">
      <div className="container">
        <a
          href="/"
          className="brand"
          aria-label="Home"
          onClick={closeMenu}
          title="Home"
        >
          <img src={logo} alt="Club logo" />
          {/* <span className="brand__ring">TOP RING</span>
          <span className="brand__title">BRAVE STEP</span> */}
        </a>

        <nav className="nav" aria-label="Primary">
          <ul className="nav__list">
            {links.map((l) => (
              <li key={l.href} className="nav__item">
                <a className="nav__link" href={l.href}>
                  {l.label}
                </a>
              </li>
            ))}
            <li className="nav__item">
              <a className="nav__link" href="/kalendars">
                Kalendārs
              </a>
            </li>
          </ul>
          <a className="cta" href="/#contact">Pierakstīties</a>
        </nav>

        {/* Mobile toggle */}
        <button
          className="mobile-toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="mobile-panel"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="mobile-toggle__bar" />
          <span className="mobile-toggle__bar" />
          <span className="mobile-toggle__bar" />
        </button>
      </div>

      {/* Mobile panel */}
      <div
        id="mobile-panel"
        className={`mobile-panel ${open ? "is-open" : ""}`}
        role="dialog"
        aria-modal="true"
      >
        <div className="mobile-panel__inner">
          <ul className="mobile-menu">
            {links.map((l) => (
              <li key={l.href} className="mobile-menu__item">
                <a href={l.href} onClick={closeMenu}>
                  {l.label}
                </a>
              </li>
            ))}
            <li className="mobile-menu__item">
              <a href="/kalendars" onClick={closeMenu}>
                Kalendārs
              </a>
            </li>
          </ul>

          <a className="mobile-cta" href="/#contact" onClick={closeMenu}>
            Pierakstīties
          </a>
        </div>
      </div>
    </header>
  );
}
